<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.2" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.14" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />


<app-navbar></app-navbar>
<app-breadcrumb></app-breadcrumb>


<div class="my-profile" fxLayoutAlign="center center">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1200px" fxFlex.lt-lg="90%" fxLayoutGap="50px">
        <div fxFlex="25%">
            <div class="lateral-bar">
                <div class="my-account">
                    <span class="jam jam-user-circle"></span>
                    <h3>Mi cuenta</h3>
                    <p>¡Hola {{ currentUser.firstname }}!</p>
                </div>
                <mat-action-list>
                    <mat-list-item [ngClass]="{'active': sectionActive == 0}" (click)="clickSection(0)"><span class="jam jam-user"></span> Mi Perfil </mat-list-item>
                    <mat-list-item [ngClass]="{'active': sectionActive == 1}" (click)="clickSection(1)"><span class="jam jam-shopping-bag"></span> Mis Compras </mat-list-item>
                    <!--<mat-list-item [ngClass]="{'active': sectionActive == 2}" (click)="clickSection(1)"><span class="jam jam-heart"></span> Favoritos </mat-list-item>-->
                    <mat-list-item (click)="onLogout()"><span class="jam jam-log-out"></span> Salir </mat-list-item>
                </mat-action-list>
            </div>
        </div>
        <div fxFlex="75%">
            <app-my-profile-section [@cardsAnimation] *ngIf="sectionActive == 0"></app-my-profile-section>
            <app-my-shopping [@cardsAnimation] *ngIf="sectionActive == 1"></app-my-shopping>
            <app-favorites [@cardsAnimation] *ngIf="sectionActive == 2"></app-favorites>
        </div>
    </div>
</div>


<app-footer></app-footer>
